import { render, staticRenderFns } from "./PriceListViewGrid.vue?vue&type=template&id=3248d545&"
import script from "./PriceListViewGrid.vue?vue&type=script&lang=js&"
export * from "./PriceListViewGrid.vue?vue&type=script&lang=js&"
import style0 from "./PriceListViewGrid.vue?vue&type=style&index=0&id=3248d545&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports